import React, { PureComponent } from 'react'
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles'
import styles from './Block.styles'
import Paper from '@material-ui/core/Paper/Paper'
import moment from 'moment'
import { BlockRecord } from 'Blocks/types/blocks'
import ErrorDisplay from 'App/components/ErrorDisplay/ErrorDisplay'
import { numberStringWithComma } from 'App/utils/numberStringWithComma'
import RectLoader from 'common/components/RectLoader/RectLoader'
import Responsive2ColumnTable from 'common/components/Responsive2ColumnTable/Responsive2ColumnTable'
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl'
import { compose } from 'recompose'
import { IGlobalState } from 'configuration/reducers'
import { languageLocaleForMomentSwitcher } from 'src/i18n/getLocale'
import { connect } from 'react-redux'

interface IBlockProps extends WrappedComponentProps, IMapStateProps {
  block?: BlockRecord
  loading: boolean
  error?: string
  retry?(): any
}

class Block extends PureComponent<IBlockProps & WithStyles> {
  renderBlock(block?: BlockRecord) {
    const timeZone =
      block && new Date(block.timestamp).toTimeString().split(/\((.*)\)/)
    const { intl, language } = this.props
    const languageLocaleForMoment = languageLocaleForMomentSwitcher(language)
    const rows = [
      {
        title: <FormattedMessage id="Blocks.components.Block.hash" />,
        content: block ? block.hash : <RectLoader height={20} width={200} />
      },
      {
        title: <FormattedMessage id="Blocks.components.Block.parentHash" />,
        content: block ? (
          block.parentHash
        ) : (
          <RectLoader height={20} width={200} />
        )
      },
      {
        title: <FormattedMessage id="Blocks.components.Block.timestamp" />,
        content: block ? (
          `${moment(block.timestamp)
            .locale(languageLocaleForMoment)
            .format('MMMM Do YYYY, h:mm:ss a')} (${moment(block.timestamp)
            .locale(languageLocaleForMoment)
            .fromNow()})`
        ) : (
          <RectLoader height={20} width={100} />
        )
      },
      {
        title: <FormattedMessage id="Blocks.components.Block.size" />,
        content: block ? (
          `${block.size} Bytes`
        ) : (
          <RectLoader height={20} width={50} />
        )
      },
      {
        title: <FormattedMessage id="Blocks.components.Block.gasLimit" />,
        content: block ? (
          numberStringWithComma(block.gasLimit)
        ) : (
          <RectLoader height={20} width={80} />
        )
      },
      {
        title: <FormattedMessage id="Blocks.components.Block.gasUsed" />,
        content: block ? (
          numberStringWithComma(block.gasUsed)
        ) : (
          <RectLoader height={20} width={60} />
        )
      },
      {
        title: <FormattedMessage id="Blocks.components.Block.extraData" />,
        content: block ? (
          block.extraData
        ) : (
          <RectLoader height={20} width={120} />
        )
      },
      {
        title: <FormattedMessage id="Blocks.components.Block.transactions" />,
        content: block ? (
          block.transactionCount
        ) : (
          <RectLoader height={20} width={40} />
        )
      }
    ]
    return <Responsive2ColumnTable rows={rows} />
  }
  render() {
    const { classes, block, error, retry } = this.props
    return error ? (
      <ErrorDisplay retry={retry} />
    ) : (
      <Paper square={true} elevation={0}>
        {this.renderBlock(block)}
      </Paper>
    )
  }
}

interface IMapStateProps {
  language: string
}

export const mapStateToProps = (state: IGlobalState): IMapStateProps => {
  return {
    language: state.app.language
  }
}

export const Unconnected = Block

export default compose<any, any>(
  injectIntl,
  withStyles(styles),
  connect(mapStateToProps, {})
)(Block)
